import { error, finish } from '../../../modules/banners/actions/change-promotion-order';
import api from '../../../api';
import {request as getAllBanners} from '../../../modules/banners/actions/get-all-banners';
export function request(dispatch, { body }) {
    api.post('/banners/order', body).then(res => {
        dispatch(finish(res));
        dispatch(getAllBanners());
    }).catch(err => {
        dispatch(error(err));
    });
}
